import { API_V4 } from "@/services/config/main-axios";

class InitService {
  init(header) {
    return API_V4.post(
      "/core/init",
      {},
      {
        headers: header
      }
    );
  }
  initSecurity() {
    return API_V4.get("/core/init-security");
  }
  support() {
    return API_V4.get("/core/support");
  }
}

export default new InitService();
